import { authorizedApi } from './index';

export const notificationsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: () => '/users/me/notifications',
    }),
    readNotifications: builder.mutation({
      query: () => ({
        url: '/users/me/notifications',
        method: 'POST',
        credentials: 'include',
      }),
    }),
    testNotifications: builder.mutation({
      query: () => ({
        url: '/users/me/notifications/test',
        method: 'POST',
        credentials: 'include',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useReadNotificationsMutation,
  useTestNotificationsMutation,
} = notificationsApi;
